export type TCurrentEnv = 'local' | 'dev' | 'stage' | 'prod';

export const getEnv = (): TCurrentEnv => {
  const hostname = window.location.hostname;
  switch (true) {
    case hostname.includes('pay-by-link.cloudbeds-dev.com'): {
      return 'dev';
    }
    case hostname.includes('pay-by-link.cloudbeds-stage.com'): {
      return 'stage';
    }
    case hostname.includes('pay-by-link.cloudbeds.com'): {
      return 'prod';
    }
    default: {
      return 'local';
    }
  }
}

export const isProd = (): boolean => {
  return getEnv() === 'prod';
}

export const isStage = (): boolean => {
  return getEnv() === 'stage';
}

export const isDev = (): boolean => {
  return getEnv() === 'dev';
}

export const isLocal = (): boolean => {
  return getEnv() === 'local';
}
